import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gw1-tree-view',
  templateUrl: './tree-view.component.html',
  styleUrls: ['./tree-view.component.css']
})
export class TreeViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
